import React, { useMemo } from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';
import { configureStore } from './redux/store/configureStore';
import { Routing } from './router/index';
import apiHandler from './services/interceptor';
import 'react-toastify/dist/ReactToastify.css';
import LogRocket from 'logrocket';
import setupLogRocketReact from 'logrocket-react';
import { ModalStackProvider } from 'components/ModalStack';

const logRocketAppId = process.env.REACT_APP_LOGROCKET_APP_ID;
if (logRocketAppId) {
  LogRocket.init(logRocketAppId);
  setupLogRocketReact(LogRocket);
}
const store = configureStore();

const AppContents = () => <Routing />;

const AppContentsWithApi = apiHandler(AppContents);

const App = () => {
  // Memoize the persistor to avoid recreating it on every render
  const persistor = useMemo(() => persistStore(store), []);

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <AppContentsWithApi />
      </PersistGate>
    </Provider>
  );
};

export default App;
